import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, filter } from 'rxjs/operators';
import { Observable, EMPTY, tap } from 'rxjs';
import { IdleActions } from '../../actions/idle/idle.actions';
import { AuthActions } from '@store/actions/auth/auth.actions';
import { IdleService } from "@services/idle.service";
import { AuthService } from '@services/auth.service';

@Injectable()
export class IdleEffects {


  startIdle$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        AuthActions.redirectEnd
      ),
      filter(() => this.authService.isAuthenticated()),
      tap(() => {
           this.idleService.startIdleWatch();
      })
    )
  },
    { dispatch: false }
  );

  constructor(
      private actions$: Actions,
      private idleService: IdleService,
      private authService: AuthService
  ) {}
}
